"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _arrow_left = _interopRequireDefault(require("../img/arrow_left.svg"));

var _arrow_right = _interopRequireDefault(require("../img/arrow_right.svg"));

function _default(palette) {
  return {
    padding: 0,
    borderColor: palette.elDivider,
    background: palette.elPrimary,
    bulletBackground: palette.elSecondaryLight,
    bulletMargin: "0 ".concat(palette.gutter * 2, "px 0 0"),
    bulletWidth: '9px',
    bulletHeight: '9px',
    activeBulletBackground: palette.elAccent,
    counterPositionBottom: palette.gutter * 2,
    counterPositionRight: palette.gutter * 3,
    counterColor: palette.tInversion,
    counterBorderRadius: '11.5px',
    counterPadding: "0 ".concat(palette.gutter, "px"),
    counterBackground: palette.elSecondaryLight,
    counterFontSize: palette.tsNormal,
    counterLineHeight: palette.tlNormal,
    counterTextShadow: "0 2px 3px rgba(0, 0, 0, 0.08), 0 0 3px rgba(0, 0, 0, 0.04)",
    navigationWidth: palette.gutter * 6,
    navigationHeight: palette.gutter * 6,
    navigationBackPositionLeft: 0,
    navigationBackPositionTop: '50%',
    navigationNextPositionRight: 0,
    navigationNextPositionTop: '50%',
    navigationBackground: palette.elDivider,
    navigationBackIcon: _arrow_left["default"],
    navigationNextIcon: _arrow_right["default"],
    navigationBorderRadius: 1,
    navigationZIndex: 50,
    navigationTransform: 'translateY(-50%)',
    hoverNavigationBackground: palette.elSecondaryLight
  };
}